<template>
  <aside>
    <div :class="$style.sidebarContent">
      <Summary
        :titles-array="summary"
        :titles-progression="titlesProgression"
      />
      <div :class="$style.cardList">
        <ColoredCard
          v-for="(card, cardId) in cardList"
          :key="cardId"
          :class="$style.card"
          :title="card.title"
          :description="card.description"
          :button-link="card.cta_link"
          :button-text="card.cta_text"
          :icon-url="card.icon.url"
          :background-color="card.background_color"
        />
      </div>
    </div>
  </aside>
</template>

<script>
import ColoredCard from '~/components/ColoredCard'

import Summary from '../Summary'

export default {
  name: 'PressSidebar',

  components: {
    Summary,
    ColoredCard,
  },

  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      titlesArray: ['Test 1', 'Test 2'],
    }
  },

  computed: {
    cardList() {
      return this.content.cardList
    },
    summary() {
      return this.content.summary
    },
    titlesProgression() {
      return this.content.titlesProgression
    },
  },

  beforeMount() {
    const element = document?.getElementById('mainRoot')
    if (element) element.style.overflowX = 'initial' // So the Summary can be sticky
  },
}
</script>

<style lang="scss" module>
.sidebarContent {
  position: sticky;
  top: 128px;
}

.card {
  margin-top: 40px;
}
</style>
